import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLivestreamComponent } from './simple-icons-livestream.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLivestreamComponent ],
    exports:      [ SimpleIconsLivestreamComponent ],
    bootstrap:    []
})
export class SimpleIconsLivestreamModule {}
